module.exports = __webpack_public_path__ + "img/grade-1.0e390b43.png";